import { FETCH_USERS_PAGINATED } from '@/store/actionTypes'

export const FETCH_CHAT_ANALYTICS_USERS = `${FETCH_USERS_PAGINATED}_FETCH_ORG_USERS`

export const FETCH_CONVERSATION_ANALYTICS = 'FETCH_CONVERSATION_ANALYTICS'
export const FETCH_CONVERSATION_ANALYTICS_SUCCESS = `${FETCH_CONVERSATION_ANALYTICS}_SUCCESS`

export const FETCH_CONVERSATION_LOGS = 'FETCH_CONVERSATION_LOGS'
export const FETCH_CONVERSATION_LOGS_SUCCESS = `${FETCH_CONVERSATION_LOGS}_SUCCESS`
